import {NodeFactory} from '@/services/node-factory';
import {BranchCondition} from "@/models/condition";

export class TreeManager {
    static addNode(workflow, node, nodeType) {
        const newNode = NodeFactory.create(nodeType, node, workflow);

        if (nodeType === 'condition') {
            newNode.children[0].children = node.children.map(child => {
                child.parentNode = newNode;
                return child;
            });
            node.children = [newNode];
        } else if (nodeType === 'branch') {
            node.children.push(newNode);
        } else {
            newNode.children = node.children.map(child => {
                child.parentNode = newNode;
                return child;
            });

            node.children = [newNode];
        }

        workflow.refresh()

        return newNode;
    }

    static removeNode(workflow, parentNode, node) {
        if (node.type === 'condition') {
            parentNode.children = node.children[0].children;
        } else if (node.type === 'branch') {
            parentNode.children.splice(parentNode.children.indexOf(node), 1);
        } else {
            parentNode.children = node.children.length ? node.children : [];
        }

        workflow.refresh()
    }

    static addBranchCondition(workflow, node) {
        const newBranchCondition = BranchCondition.create();
        node.properties.conditions.push(newBranchCondition);

        return newBranchCondition;
    }

    static removeBranchCondition(workflow, node, condition) {
        node.properties.conditions.splice(node.properties.conditions.indexOf(condition), 1);
    }
}
